import { UtilsMisc } from '../../utils/utils.misc';

export interface IConfigGeoData {

    googleMapsApiKey: string;

}

// @dynamic
export class ConfigGeoData {

    private static _googleMapsApiKey: string = null;

    public static get googleMapsApiKey(): string {
        return ConfigGeoData._googleMapsApiKey;
    }

    public static set googleMapsApiKey(value: string) {
        ConfigGeoData._googleMapsApiKey = value;
    }

    public static assign(source: IConfigGeoData): void {
        if (UtilsMisc.isNullOrUndefinedOrEmpty(source) === false) {
            ConfigGeoData._googleMapsApiKey = source.googleMapsApiKey;
        }
    }

}
